import { StandardEvents } from '@shopify/events';
// Horizon quick-add updates the shared Haleem Rush header count as well.
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(({ cart, detail }) => {
    const count = cart?.totalQuantity ?? detail?.itemCount;
    if (typeof count !== 'number') return;
    document.querySelectorAll('.hr-chrome .cart b').forEach(badge => {
      badge.textContent = String(count);
    });
  }).catch(() => { /* Horizon's cart UI handles request errors. */ });
});
